import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SearchCardProps } from './SearchCardModel';
import { 
  SearchCardContainer, 
  CardContent, 
  CardTitle, 
  CardExcerpt, 
  CardLink 
} from './SearchCard.styled';

const SearchCard: React.FC<SearchCardProps> = ({ result, className }) => {
  const { t } = useTranslation();
  return (
    <SearchCardContainer className={className}>

      <CardContent>
        {result.categoryKey && <CardExcerpt>{t(`components.search.categories.${result.categoryKey}`)}</CardExcerpt>}
        <CardTitle>{result.title}</CardTitle>
        {result.content && <CardExcerpt>{result.content}</CardExcerpt>}
        {result.external ? (
          <CardLink href={result.url} target="_blank" rel="noopener noreferrer"
            aria-label={`${t('components.search.viewMore')}: ${result.title}. ${t('components.search.newTab')}`}>
            {t('components.search.viewMore')}
          </CardLink>
        ) : (
          <CardLink as={Link} to={result.url} aria-label={`${t('components.search.viewMore')}: ${result.title}`}>
            {t('components.search.viewMore')}
          </CardLink>
        )}
      </CardContent>
    </SearchCardContainer>
  );
};

export default SearchCard;
